import React from 'react'
import { trans } from '../../../../_providers/Translation'

function Filter(props) {

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    return (
        <form className="filter-standard">
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1" selected>
                        {trans('filters.name')}
                    </option>
                    <option value="2">
                        {trans('filters.email')}
                    </option>
                    <option value="3">
                        {trans('filters.phone')}
                    </option>
                    <option value="4">
                        {trans('filters.address')}
                    </option>
                    <option value="5">
                        {trans('filters.active')}
                    </option>
                    <option value="6">
                        {trans('filters.superPartner')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="1">
                <input
                    type="search"
                    name="name"
                    onKeyUp={(e) => props.handleSearch(e.target.name, e.target.value)}
                    onChange={(e) => props.handleSearch(e.target.name, e.target.value)}
                    value={props.name}
                    placeholder={trans('labels.search')}
                />
            </div>

            {/* <div className="col" data-id="2">
                <label>
                    {trans('labels.email')}
                </label>
                <input
                    type="search"
                    name="email"
                    onKeyUp={(e) => props.handleSearch(e.target.name, e.target.value)}
                    onChange={(e) => props.handleSearch(e.target.name, e.target.value)}
                    defaultValue={props.email}
                />
            </div>

            <div className="col" data-id="3">
                <label>
                    {trans('labels.phone')}
                </label>
                <input
                    type="search"
                    name="phone"
                    onKeyUp={(e) => props.handleSearch(e.target.name, e.target.value)}
                    onChange={(e) => props.handleSearch(e.target.name, e.target.value)}
                    defaultValue={props.phone}
                />
            </div>

            <div className="col" data-id="4">
                <label>
                    {trans('labels.address')}
                </label>
                <input
                    type="search"
                    name="address"
                    onKeyUp={(e) => props.handleSearch(e.target.name, e.target.value)}
                    onChange={(e) => props.handleSearch(e.target.name, e.target.value)}
                    defaultValue={props.address}
                />
            </div>

            <div className="col" data-id="5">
                <div className="checkbox-primary">
                    <label htmlFor="search-active">
                        {trans('labels.active')}
                        <input
                            id="search-active"
                            type="checkbox"
                            name="active"
                            onChange={(e) => props.handleSearch(e.target.name, Number(e.target.checked))}
                            defaultChecked={props.active ? true : false}
                        />
                        <div className="checkmark"></div>
                    </label>
                </div>
            </div>

            <div className="col" data-id="6">
                <div className="checkbox-primary">
                    <label htmlFor="search-superpartner">
                        {trans('labels.superPartner')}
                        <input
                            id="search-superpartner"
                            type="checkbox"
                            name="superpartner"
                            onChange={(e) => props.handleSearch(e.target.name, Number(e.target.checked))}
                            defaultChecked={props.superpartner ? true : false}
                        />
                        <div className="checkmark"></div>
                    </label>
                </div>
            </div> */}

        </form>
    )
}

export default Filter